import { render, staticRenderFns } from "./FilesDash.vue?vue&type=template&id=ea4782c0&scoped=true"
import script from "./FilesDash.vue?vue&type=script&lang=js"
export * from "./FilesDash.vue?vue&type=script&lang=js"
import style0 from "./FilesDash.vue?vue&type=style&index=0&id=ea4782c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea4782c0",
  null
  
)

export default component.exports